import { Type } from 'class-transformer';
import {
  IsArray,
  IsDate,
  IsDefined,
  IsEnum,
  IsNotEmpty,
  IsOptional,
  IsString,
  ValidateNested,
} from 'class-validator';
import { BaseDto } from '../../@base/base.dto';
import { SmsId } from '../../types';
import { SmsActions } from './sms-actions.type';
import { SmsStatus } from './sms-status.enum';
import { SmsTag } from './sms-tags.enum';
import { SmsAttemptDto } from './sub-dto/sms-attempt.dto';
import { SmsContextDto } from './sub-dto/sms-context.dto';

export class SmsSummaryDto extends BaseDto<SmsId> {
  @IsString()
  @IsNotEmpty()
  action!: SmsActions;

  @IsEnum(SmsStatus)
  @IsNotEmpty()
  status!: SmsStatus;

  @IsEnum(SmsTag)
  @IsNotEmpty()
  tag!: SmsTag;

  @IsString()
  @IsNotEmpty()
  to!: string;

  @IsString()
  @IsOptional()
  from?: string;

  @ValidateNested()
  @Type(() => SmsContextDto)
  @IsDefined()
  context!: SmsContextDto;

  @IsString()
  @IsNotEmpty()
  content!: string;

  @IsDate()
  @IsOptional()
  sendDate?: Date;

  @IsString()
  @IsOptional()
  gatewayMessageId?: string;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => SmsAttemptDto)
  attempts!: SmsAttemptDto[];
}
